import * as React from 'react';
import ProjectLeftPanelTitle from './ProjectLeftPanelTitle';

type ProjectLeftPanelTitleProps = {
    title: string | JSX.Element,
    addBtn?: React.ReactChild
    children: React.ReactChild
    className?: string
    itemsCount?: number
    collapsed?: boolean
    onCollapsedClick?: () => void;
}

function ProjectLeftPanelCollapsible({ title, addBtn, children, className, itemsCount, collapsed, onCollapsedClick }: ProjectLeftPanelTitleProps) {
    return (
        <div
            className={`ProjectLeftPanel__collapsible ${className} ${collapsed === true ? 'collapsed' : ''}`}>
            <ProjectLeftPanelTitle title={title} addBtn={addBtn} collapsed={collapsed} onCollapsedClick={onCollapsedClick} />

            <div className="ProjectLeftPanel__collapsible-content">
                {children}
            </div>
        </div>
    );
}

export default ProjectLeftPanelCollapsible;
